<template>
    <div class="flex w-full items-center justify-between gap-2">
        <div
            class="min-w-0 flex-1"
            :class="[disabled ? 'cursor-not-allowed text-content-disabled' : 'text-content-primary']"
        >
            <div class="flex flex-wrap items-center gap-x-2 text-content-lg">
                <p class="font-semibold capitalize">{{ role }}</p>
                <p>{{ first }} {{ last }}</p>
            </div>
            <p class="text-content-md">
                <slot name="subtitle">
                    {{ email }}
                </slot>
            </p>
            <p
                v-if="helperText"
                class="text-content-sm"
            >
                {{ helperText }}
            </p>
        </div>
        <div
            v-if="$slots.trailing"
            class="flex-shrink-0"
        >
            <slot name="trailing" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Client } from '@/components/Views/Company/File/file.types';

defineProps<{
    role: Client['role'];
    first: Client['first'];
    last: Client['last'];
    email: Client['email'];
    disabled?: boolean;
    helperText?: string;
}>();
</script>
